import React from "react";
import PropTypes from "prop-types";
import { HourlyRateRange, ProfileRateRange } from "components/Profile";
import { Tag } from "components/Tags";

/**
 * ApplicationRateForClient
 *
 * @param {Object} application
 */
const ApplicationRateForClient = ({ application, display }) => {
  if (!application) return null;

  const rate =
    application?.negotiatedSellingRate?.amount && application?.negotiatedSellingRate?.currency
      ? {
          low: application?.negotiatedSellingRate?.amount,
          high: application?.negotiatedSellingRate?.amount,
          currency: application?.negotiatedSellingRate?.currency,
        }
      : {
          low: application?.sellingRateRange?.hourly?.low,
          high: application?.sellingRateRange?.hourly?.high,
          currency: application?.sellingRateRange?.currency,
        };

  if (!rate.low && !rate.high) return null;

  if (display === RATE_DISPLAYS.tag) {
    return (
      <Tag>
        <HourlyRateRange {...rate} />
      </Tag>
    );
  }

  return <ProfileRateRange {...rate} />;
};

const RATE_DISPLAYS = {
  tag: "tag",
  rateComponent: "rateComponent",
};

ApplicationRateForClient.defaultProps = {
  display: RATE_DISPLAYS?.rateComponent,
};

ApplicationRateForClient.propTypes = {
  application: PropTypes.object.isRequired,
  display: PropTypes.string,
};

export default ApplicationRateForClient;

export { RATE_DISPLAYS };
